module.exports = __webpack_public_path__ + "static/media/img_black_cat.5c748b48.png";